export const environment = {
    divipo: '76892000',
    secretary: 'SECRETARIA DE MOVILIDAD DE YUMBO',
    municipality: 'YUMBO - VALLE DEL CAUCA',
    envType: 'yumbo',

    logoAlcaldia: 'assets/logo-alcaldia-yumbo.png',
    shield: 'assets/shield-yumbo.png',
    loginTitle: 'YUMBO',

    pdfMonkeyTemplates: {
        comparendo: '3C31CF36-3CF5-449F-A648-281B13F81118',
        tirillaRetencion: 'D728A2ED-0354-4659-983E-27A24F1F7875',
        tirillaComparendo: 'DD98B0D6-C45C-42DF-9F61-CFBDDE3807C4',
    },

    defaultLocation: {
        lat: 3.583329,
        lng: -76.491007
    },

    apiUrlBase: `https://appcentral.pre.sap-yumbo.com/`,
    apiUrlExternal: `https://police-code-or.pre.sap-yumbo.com/api/`,
    s3FilesBaseUrl: `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,

    tirillaComparendoConfig: {
      envType: 'yumbo',
      secretary: 'SECRETARIA DE MOVILIDAD DE YUMBO',
      municipality: 'YUMBO - VALLE DEL CAUCA',
      logoUrl: 'https://contravencional-public-logos.s3.us-east-1.amazonaws.com/logo-alcaldia-yumbo.png',
      s3FilesBaseUrl: `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      signatureBaseUrls: [
        `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      ],
    },
    tirillaRetencionConfig: {
      envType: 'yumbo',
      secretary: 'SECRETARIA DE MOVILIDAD DE YUMBO',
      municipality: 'YUMBO - VALLE DEL CAUCA',
      logoUrl: 'https://contravencional-public-logos.s3.us-east-1.amazonaws.com/logo-alcaldia-yumbo.png',
      s3FilesBaseUrl: `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      signatureBaseUrls: [
        `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      ],
    },
    ordenUnicaComparendoConfig: {
      envType: 'yumbo',
      secretary: 'SECRETARIA DE MOVILIDAD DE YUMBO',
      municipality: 'YUMBO - VALLE DEL CAUCA',
      s3FilesBaseUrl: `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      signatureBaseUrls: [
        `https://yumbo-pre-paico-files.s3.us-east-1.amazonaws.com`,
      ],
      colombiaShieldUrl: 'https://contravencional-public-logos.s3.us-east-1.amazonaws.com/col-escudo.png',
      entityShieldUrl: 'https://contravencional-public-logos.s3.us-east-1.amazonaws.com/yumbo-escudo.png',
      transportShieldUrl: 'https://contravencional-public-logos.s3.us-east-1.amazonaws.com/min-tra-escudo.png',
      agentEntity: 'SECRETARÍA DE TRÁNSITO Y TRANSPORTE DE YUMBO',
    },
};

